import React, { useContext } from "react";
import { useTable } from "react-table";
import PropTypes from "prop-types";
import { MarketingContext } from "../../../contexts";
import moment from "moment";

export default function TableLayout() {
    const { data, columns } = useContext(MarketingContext);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data
    })

    function renderCellComponent(cell) {
        const { Header } = cell.column;
        const { original } = cell.row;

        switch (Header) {
            case "Code":
                return <td className="px-2 text-left w-fit" key={`${original.id}_code`}>{original.shortCode}</td>;
            case "Type":
                return <td className="px-2 text-left w-fit" key={`${original.id}_type`}>{original.type}</td>;
            case "isPublic":
                return <td className="px-2 text-left w-fit" key={`${original.id}_isPublic`}>{original.isPublic ? "Yes" : "No"}</td>;
            case "Created At":
                return <td className="px-2 text-left w-fit" key={`${original.id}_createdAt`}>{moment(original.createdAt).format("DD-MM-YYYY")}</td>;
            case "Source":
                return (
                    <td
                        className="py-4 text-left pl-3 font-sans font-medium"
                        key={original.id}>
                        {original.data.source}
                    </td>
                )
            case "Medium":
                return (
                    <td
                        className="py-4 text-left pl-3 font-sans font-medium"
                        key={original.id}>
                        {original.data.medium}
                    </td>
                )
            case "Campaign":
                return (
                    <td
                        className="py-4 text-left pl-3 font-sans font-medium"
                        key={original.id}>
                        {original.data.campaign}
                    </td>
                )
            default:
                return <td className="px-2 text-left" key={`${original.id}_${cell.getCellProps().key}`} {...cell.getCellProps()}> {cell.render("Cell")}</td >;
        }
    }
    return (

        <div className="block bg-white rounded-2xl shadow-soft-xl w-[100%] bg-[white] mt-4 p-2 px-4  dark:hover:bg-gray-700">
            <table {...getTableProps()} className="table-auto w-[100%] font-sans">
                <thead className="text-center border-b-2 border-gray-50 h-16">
                    {headerGroups.map((headerGroup, id) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={id} className="text-left border-b-2 border-gray-100">

                            {headerGroup.headers.map((column, id) => (
                                <th {...column.getHeaderProps()} key={id} className="font-sans text-left pl-3">{column.render("Header")}</th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, id) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} key={id} className="hover:bg-white px-2 border-b text-left border-gray-50 pl-3 font-sans">
                                {row.cells.map((cell, id) => {
                                    return <React.Fragment key={id}>
                                        {renderCellComponent(cell)}
                                    </React.Fragment>
                                })}

                            </tr>
                        );
                    })}
                </tbody>
            </table >
        </div>
    )

}
TableLayout.propTypes = {
    columns: PropTypes.any,
    data: PropTypes.any,
    refetch: PropTypes.any


};




